import { useEvaluation } from 'hooks/useEvaluation';
import { useDisclose } from 'hooks/utilHooks';
import { IEvaluation } from 'types/Evaluation';
import { maskCpf, maskDate } from 'util/masks';

import CloseIcon from '@mui/icons-material/Close';
import SearchIcon from '@mui/icons-material/Search';
import StarIcon from '@mui/icons-material/Star';
import {
  Dialog,
  DialogContent,
  DialogTitle,
  Divider,
  IconButton,
  Rating,
  Stack,
  TableCell,
  TableRow,
  Tooltip,
} from '@mui/material';
import { styled } from '@mui/styles';

const StyledTableRow = styled(TableRow)(() => ({
  '&:nth-of-type(odd)': {
    backgroundColor: '#fafafa',
  },
}));

const StyledTableCell = styled(TableCell)(() => ({
  color: '#4B4B4B',
}));

export interface IEvaluationRow {
  evaluation: IEvaluation;
}

export const EvaluationRow: React.FC<IEvaluationRow> = ({ evaluation }) => {
  const { isOpen, onClose, onOpen } = useDisclose();
  const { setSnackbar } = useEvaluation();

  const handleOnClick = () => {
    if (Boolean(evaluation.evaluation.feedback)) {
      onOpen();
      return;
    }
    setSnackbar({
      message: 'Essa avaliação não tem comentário!',
      variant: 'warning',
    });
  };

  return (
    <StyledTableRow>
      <TableCell component="th" scope="row" sx={{ color: '#4B4B4B' }}>
        {maskDate(evaluation?.createdAt)}
      </TableCell>

      <StyledTableCell>{evaluation?.pet?.tutor?.name}</StyledTableCell>

      <StyledTableCell>{evaluation?.vet?.name}</StyledTableCell>

      <StyledTableCell> {maskCpf(evaluation?.vet?.cpf)} </StyledTableCell>

      <TableCell>
        <Stack direction="row">
          <Rating
            readOnly
            size="small"
            value={evaluation?.evaluation?.grade}
            emptyIcon={
              <StarIcon style={{ color: '#D9D9D9' }} fontSize="inherit" />
            }
          />
        </Stack>
      </TableCell>

      <TableCell align="right">
        <Stack flexDirection="row" gap="8px" justifyContent="flex-end">
          <Tooltip title="Ver comentário">
            <IconButton
              aria-label="edit"
              color="inherit"
              onClick={handleOnClick}
            >
              <SearchIcon />
            </IconButton>
          </Tooltip>
        </Stack>
      </TableCell>

      <Dialog open={isOpen} onClose={onClose}>
        <DialogTitle>
          <Stack minWidth={560}>Avaliação</Stack>
          <IconButton
            aria-label="close"
            onClick={onClose}
            sx={{
              position: 'absolute',
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <Divider />
        <DialogContent>{evaluation?.evaluation?.feedback}</DialogContent>
      </Dialog>
    </StyledTableRow>
  );
};

